import Instance from '../../../../Axios';

// New Actions for the app

const GetObra = (obraId, setObraSelecionada) => async (dispatch) => {
  await Instance()
    .get(`/energias/obras/${obraId}`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: 'GET_ENERGIAS_OBRA', payload: data.yData[0] });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObra;
